import styled, { css } from "styled-components";

const CartContainer = styled.div`
    margin-bottom: 35px;
    position: realtive;

    .cart-loading {
        top: 0;
        left: 0;
        padding-top: 20px;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.5);
    }

    .cart-container-main {
        > .lt-sec-main {
            @media (min-width: 992px) {
                padding-right: 25px;
            }
        }
        > .rt-sec-main {
            @media (min-width: 992px) {
                padding-left: 25px;
                position: sticky;
                top: 10px;
            }
        }
    }

    .please-add {
        background: #efefef;
        text-align: center;
        padding: 12px 10px 11px;
        color: #666;
        font-size: 14px;
        border: 1px solid #333;
        margin-top: 15px;
    }
    .rt-sec-main {
        width: 100%;
        @media (min-width: 992px) {
            width: 350px;        
        }
        > .inner {
            padding: 25px;
            border: 2px solid #333;
        }
        .header-part {
        }
    }
`;
export default CartContainer;
